export default __webpack_public_path__ + "media/images/react_icons/error-circle-times-60bc91814714b27f8dc8fa640f0dd5ff.svg";